@file:Suppress("MagicNumber")

package com.nonopn.skydome.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier

import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.certfoudr.CertFoudrScreen
import com.nonopn.skydome.common.app.pages.sharing.createShareManager
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_sr_certificates
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem

import eu.codlab.navigation.NavTypeWrapper
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterParameters

import kotlinx.serialization.Serializable

import kotlin.reflect.KType

@Serializable
data class RouteCertFoudr(
    val projectUuid: String,
    val projectName: String,
    val projectLat: Double,
    val projectLon: Double,
    val impactLat: Double,
    val impactLon: Double,
    val impactTimestamp: Long,
    val impactAmplitude: Int,
    val impactPercent: Double,
    val impactExternalId: String,
) : RouteParameterTo

object RouterCertFoudr : RouterParameters<RouteCertFoudr>(RouteCertFoudr::class) {
    override val typeMap: Map<KType, NavTypeWrapper<Any>> get() = emptyMap()

    override fun routeFrom(parameters: RouteCertFoudr) =
        "/certificate/lightning/${parameters.projectUuid}"

    @Composable
    override fun Show(parameters: RouteCertFoudr) {
        RouteCertFoudrImpl(parameters).scene()
    }

    override fun navigateTo(instance: RouteCertFoudr) = NavigateTo(
        route = instance,
        stack = NavigateToStack(
            popBackStack = false,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        routeParameterTo is RouteCertFoudr

    override fun isMatching(route: String) = route.startsWith("/certificate/lightning/")

    override fun navigateFrom(path: String): RouteCertFoudr = TODO()
}

class RouteCertFoudrImpl(params: RouteCertFoudr) : Route<RouteCertFoudr>(
    route = "/certificate/lightning/${params.projectUuid}",
    params = params
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val shareManager = remember { createShareManager() }
        LaunchedEffect(Unit) { onEntryIsActive(appModel) }

        CertFoudrScreen(
            modifier = Modifier.fillMaxSize(),
            projectName = params.projectName,
            projectUuid = params.projectUuid,
            projectLat = params.projectLat,
            projectLon = params.projectLon,
            impactLat = params.impactLat,
            impactLon = params.impactLon,
            impactTimestamp = params.impactTimestamp,
            impactAmplitude = params.impactAmplitude,
            impactPercent = params.impactPercent,
            impactExternalId = params.impactExternalId,
            shareManager = shareManager,
            appModel = appModel,
        )
    }

    private fun onEntryIsActive(appModel: AppModel) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.menu_sr_certificates,
                emptyList<MenuItem>()
            )
        )
    }
}
